<template>
  <TimeAndPrioritiesManager />
</template>

<script>
// TODO: Delete?
import TimeAndPrioritiesManager from '@/components/CalendarPage/TimeAndPrioritiesManager'

export default {
  name: "ManageTimeSubpage",
  components: {
    TimeAndPrioritiesManager
  }
};
</script>
